var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { FileUploaderButton, StyledText, FileUploadButtonIconBorder, } from './elements';
import { InternalProvider } from '../../../util/InternalProvider';
import { Icon } from '../../Icon';
import { AsurionLoadingSpinner } from '../../Loaders';
import { useHoverState } from '../../../util';
export var FileUploadButton = forwardRef(function (_a, fRef) {
    var _b = _a.iconSrc, iconSrc = _b === void 0 ? 'PlusAdd' : _b, label = _a.label, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, _e = _a.isPrimaryAction, isPrimaryAction = _e === void 0 ? false : _e, onClick = _a.onClick, rest = __rest(_a, ["iconSrc", "label", "disabled", "isLoading", "isPrimaryAction", "onClick"]);
    var _f = useHoverState(disabled), hoverState = _f.hoverState, onMouseEvents = __rest(_f, ["hoverState"]);
    return (React.createElement(InternalProvider, null,
        React.createElement(FileUploaderButton, __assign({ disabled: disabled, onClick: function (e) {
                !isLoading && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
            }, isLoading: isLoading, hoverState: hoverState }, onMouseEvents, rest, { ref: fRef }),
            isLoading ? (React.createElement(AsurionLoadingSpinner, { "data-testid": "file-upload-button-loading-spinner", width: "2rem" })) : (iconSrc && (React.createElement(FileUploadButtonIconBorder, { disabled: disabled, isPrimaryAction: isPrimaryAction, hoverState: hoverState },
                React.createElement(Icon, { src: iconSrc, size: 'medium' })))),
            React.createElement(StyledText, { size: 2, weight: "base", forwardedAs: 'p', isLoading: isLoading, disabled: disabled, hoverState: hoverState }, label))));
});
